<template>
    <section class="page-section" v-loading="pageLoading">
                
                <el-form size="small" :model="form" :rules="rules" label-width="110px" class="content-form no-padding-bottom pt20" ref="form">
                    <el-form-item label="公司代理名称" prop="name">
                        <el-input class="w300" v-model="form.name" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="公司联系人" prop="contact">
                        <el-input class="w300" v-model="form.contact" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人手机号" prop="mobile">
                        <el-input class="w300" v-model="form.mobile" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="初始密码" prop="password">
                        <el-input class="w300" v-model="form.password" placeholder="请输入" resize="none"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="handleCommit('form')" :loading="btnLoading">确定</el-button>
                        <el-button size="small" type="default" plain @click="handleback">取消</el-button>
                    </el-form-item>
                </el-form>
            </section>
</template>

<script>
import { agentCompanySaveOrUpdate } from '../../../common/api';

export default {
    data() {
        return {
            id: this.$route.query.id,
            form: {
                name: '',
                contact: '',
                mobile: '',
                password: '123456'
            },

            pageLoading: false,
            btnLoading: false,

            rules: {
                name: [
                    { required: true, message: '请输入公司代理名称', trigger: 'blur' }
                ],
                contact: [
                    { required: true, message: '请输入公司联系人', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入联系人手机号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入初始密码', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        let query = this.$route.query
        if (query.id) {
          const { name, contact, mobile, password } = query.row
          Object.assign(this.form, {
            name,
            contact,
            mobile,
            password
          })
        }
    },
    methods: {
        /**
         * [handleCommit description] 提交
         * @param  {[type]} formName [description]
         * @return {[type]}          [description]
         */
        handleCommit: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    const { name, contact, mobile, password } = this.form
                    let param = {
                        type: 0,
                        name,
                        contact,
                        mobile,
                        password
                    }

                    if(this.id) {
                        param.id = this.id;
                    }

                    agentCompanySaveOrUpdate(param).then(res =>{
                        this.btnLoading = false;

                        let { code, data, msg } = res;

                        if(code == 0) {
                            this.$message.success('保存成功');
                            this.handleback()
                        } else {
                            this.$message.error(msg);
                        }
                    }).catch(error => {
                        this.btnLoading = false;
                        this.$message.error('服务器异常');
                    });
                    
                } else {
                    return false;
                }
            });
        },
        /**
         * [handleback description] 取消-返回列表
         * @return {[type]}          [description]
         */
        handleback: function() {
            this.$router.push('/agent/company/list');
        },
    }
}
</script>

<style lang="scss" scoped>
</style>

